<mat-toolbar color="primary">

    <a (click)="logout()">
        <img src="../../../assets/toobook-logo-branco.png" alt="Logo Toobook" />
    </a>

    <nav *ngIf="menuService.exibeMenu$ | async">
        <p><a class="link link_menu" href="#como_funciona">Como Funciona</a></p>
        <p><a class="link link_menu" href="#toobook">Conheça a TooBook</a></p>
        <p><a class="link link_menu" href="#contato">Contato</a></p>
        <p><a class="link link_menu" href="/politica-vendas">Política de vendas</a></p>

        <button class="btn_minhas_compras" (click)="onAcessaCompras()">
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M7 11.5v-2h10v2M12 2a4 4 0 0 0-4 4v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-2V6a4 4 0 0 0-4-4zM12 4a2 2 0 0 1 2 2v2h-4V6a2 2 0 0 1 2-2z"></path>
          </svg>
          Minhas compras
        </button>
    </nav>

    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="btn-menu" (menuOpened)="isMenuAberto = true" (menuClosed)="isMenuAberto = false" *ngIf="menuService.exibeMenu$ | async">
      <mat-icon>{{isMenuAberto ? 'close' : 'menu'}}</mat-icon>
    </button>
    <mat-menu #menu="matMenu" xPosition="before">
        <button mat-menu-item>
          <span> <a href="#como_funciona">Como Funciona?</a></span>
        </button>
        <button mat-menu-item>
          <span> <a href="#toobook">Conheça a TooBook</a></span>
        </button>
        <button mat-menu-item>
          <span> <a href="#contato">Contato</a></span>
        </button>
        <button mat-menu-item>
          <span> <a href="/politica-vendas">Política de vendas</a></span>
        </button>
        <button mat-menu-item (click)="onAcessaCompras()">
          <span> Minhas Compras</span>
        </button>
    </mat-menu>

    <!-- <span class="toolbar-spacer"></span>

    <button mat-icon-button matTooltip="Sair" (click)="logout()">
        <mat-icon>logout</mat-icon>
    </button> -->
</mat-toolbar>

<router-outlet></router-outlet>